import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import axios from 'axios';

export const saveFormEditorFormService = async (
  formEditorFormDraft,
  s3Keys
) => {
  const apiPath = 'form-editor';
  const body = { formEditorFormDraft, s3Keys };

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    data: body,
  };

  const signedRequest = await createSignedRequest(request);

  const res = await axios(signedRequest);

  return res.data;
};
